import React from 'react';
import { Box } from '@mui/material';

import { formatChange, ScrapedChange } from './format';

export default function ScrapedChanges({ changes }: { changes: ScrapedChange[] }) {
    const visible = changes.filter((change) => (
        change.unmatched.length > 0 || change.current !== change.scraped
    ));
    if (!visible.length) {
        return <Box component="span">Ingen skillnad</Box>;
    }
    return (
        <Box component="span" sx={{ display: 'block' }}>
            {visible.map((change) => (
                <Box
                    key={change.key}
                    component="span"
                    sx={{
                        display: 'block',
                        color: change.protected ? '#006D77' : 'inherit',
                        fontWeight: change.protected ? 600 : 400
                    }}
                >
                    {formatChange(change)}
                </Box>
            ))}
        </Box>
    );
}
